/**
 * Synchronous guard to suppress "Leave site?" prompts during intentional navigation.
 *
 * Call `markIntentionalNavigation()` immediately before any intentional page leave
 * (window.location.href assignment, navigateTo dispatch, signoutRedirect).
 *
 * The beforeunload handler and React Router useBlocker check this guard synchronously,
 * bypassing the async React render cycle that causes race conditions with Redux state.
 */
let _navigatingAway = false;

export const markIntentionalNavigation = (): void => {
  _navigatingAway = true;
};

export const clearIntentionalNavigation = (): void => {
  _navigatingAway = false;
};

export const isIntentionalNavigation = (): boolean => _navigatingAway;
